// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31TW2","left":"styles_left__1dx7s"};